module.exports = __webpack_public_path__ + "img/rtIcon.ff2838c2.png";